import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from './models'
import { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    addValues: store.actions.standalone({
      data: store.actions.Data.asIs<{ request: models.Values.AddRequest }>(),
      reducer: ({ state, data: { request } }) =>
        State.addValues(state, request),
    }),
    applyValuesFor: store.actions.standalone({
      data: store.actions.Data.asIs<{ holder: models.Values.Holder }>(),
      reducer: ({ state, data: { holder } }) =>
        State.applyValuesFor(state, holder),
    }),
    putDefinitions: store.actions.standalone({
      data: store.actions.Data.asIs<{
        holder: models.Definition.Holder
        variables: readonly models.Definition[]
      }>(),
      reducerDeprecated: (state, { holder, variables }) =>
        State.putDefinitions(state, holder, variables),
    }),
    putValues: store.actions.standalone({
      data: store.actions.Data.asIs<models.Values.PutRequest>(),
      reducerDeprecated: (state, request) => State.putValues(state, request),
    }),
    removeFocused: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducerDeprecated: state => State.removeFocused(state),
    }),
    reset: store.actions.standalone({
      data: store.actions.Data.asIs<{ holder: models.Values.Holder }>(),
      reducer: ({ state, data: { holder } }) => State.reset(state, holder),
    }),
    setFocused: store.actions.standalone({
      data: store.actions.Data.asIs<models.Values.Holder>(),
      reducerDeprecated: (state, holder) => State.setFocused(state, holder),
    }),
    updateValue: store.actions.standalone({
      data: store.actions.Data.asIs<models.Values.UpdateRequest>(),
      reducerDeprecated: (state, variableValue) =>
        State.updateValue(state, variableValue),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
